module.exports = __webpack_public_path__ + "img/bsbx.3dc9eed7.svg";